<template>
  <div class="w-full relative">
    <div
      class="rounded-big w-full  shadow bg-white h-full relative"
      :style="backgroundColor ? { 'background-color': backgroundColor } : null"
      :class="{ 'overflow-hidden': !overflowVisible }"
    >
      <div v-if="title" class="flex justify-between px-8 pt-6 items-center">
        <div class="text-blue font-title font-semibold text-base text-lg">
          {{ title }}
        </div>
        <div v-if="closable">
          <c-icon
            name="CloseFilled"
            class="text-gray-350 cursor-pointer"
            @click="$emit('close')"
          />
        </div>
        <slot v-else name="top-right" />
      </div>
      <div
        v-else-if="$slots['top-right']"
        class="flex flex-row items-end justify-end pt-6 pr-6"
      >
        <slot name="top-right" />
      </div>
      <div
        v-if="description"
        class="px-8 pt-3 items-center text-xs text-gray-350 font-body"
      >
        {{ description }}
      </div>
      <div
        v-if="loading"
        class="absolute top-0 left-0 bottom-0 right-0 transparent-background z-40 flex items-center justify-center"
      >
        <n-spin size="medium" />
      </div>
      <div v-else :class="{ 'p-8': contentPadding }">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import CIcon from './CIcon.vue'

export default {
  name: 'CCard',
  props: {
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    contentPadding: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    overflowVisible: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  components: {
    CIcon
  }
}
</script>

<style scoped>
.transparent-background {
  background-color: rgba(30, 32, 31, 0.5);
}
</style>
